import useGames from '../../lib/hooks/useGames';
import { Button, Layout } from '../../components';
import styles from './GameCardViewPage.module.scss';
import { useEffect } from 'react';
import { Descriptions, Tag } from 'antd';
import { DownCircleTwoTone, StopTwoTone } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { API_URL } from '../../lib/api/index';
import { availabilityGroup } from '../../components/common/EddingGameCard/config';
import cn from 'classnames';
import { EDIT_GAME_CARD_PAGE } from '../../lib';

const GameCardViewPage = ({ logOut }: { logOut: () => void }) => {
  const { onGetOneGameCard, gameCard, loading, onGetGamesCard, gameCards } = useGames();
  const navigate = useNavigate();

  useEffect(() => {
    onGetOneGameCard();
    !!gameCard?.vaccineCardId && onGetGamesCard();
  }, []);

  const onEditCard = () => {
    navigate(`${EDIT_GAME_CARD_PAGE}?id=${gameCard?._id}`);
  };

  return (
    <Layout
      logOut={logOut}
      loading={loading}
      title={
        <div className={styles.layoutTitle}>
          <div>Game card</div>
          <Button label={'Edit'} bg="#000" color="#fff" onClick={onEditCard} />
        </div>
      }
    >
      {!loading && (
        <Descriptions
          style={{ maxWidth: 1000 }}
          labelStyle={{ fontWeight: 700, fontSize: 14 }}
          size="small"
          bordered
        >
          <Descriptions.Item label="Index" span={3}>
            {gameCard?.indexName?.toUpperCase()}
          </Descriptions.Item>
          <Descriptions.Item label="Type" span={3}>
            {gameCard?.type.toUpperCase()}
          </Descriptions.Item>
          <Descriptions.Item label="Description" span={3}>
            <div>
              <div style={{ marginBottom: 10 }}>
                <Tag color="#00ADB5">EN:</Tag>
                {gameCard?.eng?.description}
              </div>
              <div>
                <Tag color="#87d068">RU:</Tag>
                {gameCard?.ru?.description}
              </div>
            </div>
          </Descriptions.Item>
          {!!gameCard?.eng?.answers?.length && (
            <Descriptions.Item label="Answers" span={3}>
              {gameCard?.eng?.answers.map((item, idx) => (
                <div
                  key={idx}
                  className={cn(styles.answerItem, {
                    [styles.answerItem__border]: idx !== 3,
                  })}
                >
                  <div>
                    {item.isCorrectAnswer ? (
                      <DownCircleTwoTone twoToneColor="#7CFC00" />
                    ) : (
                      <StopTwoTone twoToneColor="#FF0000" />
                    )}
                  </div>
                  <div>
                    <div style={{ marginBottom: 2 }}>
                      <Tag color="#00ADB5">EN:</Tag>
                      {item.value}
                    </div>
                    <div>
                      <Tag color="#87d068">RU:</Tag>
                      {gameCard?.ru?.answers?.[idx]?.value}
                    </div>
                  </div>
                </div>
              ))}
            </Descriptions.Item>
          )}
          {gameCard?.musicQuizTrackName && (
            <Descriptions.Item label="Music quiz track" span={3}>
              <audio
                controls
                src={`${API_URL}/storage/audio/${gameCard?.musicQuizTrackName}`}
              ></audio>
            </Descriptions.Item>
          )}
          <Descriptions.Item label="Likes count" span={3}>
            {gameCard?.likesCount}
          </Descriptions.Item>
          {gameCard?.type !== 'vaccine' && (
            <Descriptions.Item label="Points awarded" span={3}>
              {gameCard?.resultCard}
            </Descriptions.Item>
          )}
          {gameCard?.declineResultCard && (
            <Descriptions.Item label="Points for refusing" span={3}>
              {gameCard?.declineResultCard}
            </Descriptions.Item>
          )}
          {gameCard?.vaccineCardId && (
            <Descriptions.Item label="Vaccine card" span={3}>
              <div>
                <b>ID:</b>{' '}
                <span style={{ color: '#03AED2' }}>
                  <Link to={`/game_card_view?id=${gameCard?.vaccineCardId}`}>
                    {gameCard?.vaccineCardId}
                  </Link>
                </span>
              </div>
              <div>
                <b>DESCRIPTION:</b>{' '}
                {gameCards?.find(i => i.vaccineCardId === gameCard?.vaccineCardId)?.eng.description}
              </div>
            </Descriptions.Item>
          )}
          <Descriptions.Item label="Availability group" span={3}>
            <div className={styles.tagList}>
              {gameCard?.availabilityGroup?.map((i, index) => {
                const label = availabilityGroup.eng.find(v => v.value === i)?.label;

                if (!label) {
                  return (
                    <span key={index} className={styles.tag}>
                      {i}
                    </span>
                  );
                }

                if (index === 0) {
                  return (
                    <span key={index} className={`${styles.tag} ${styles.firstTag}`}>
                      {label}
                    </span>
                  );
                }

                return (
                  <span key={index} className={styles.tag}>
                    {label}
                  </span>
                );
              })}
            </div>
          </Descriptions.Item>
        </Descriptions>
      )}
    </Layout>
  );
};

export default GameCardViewPage;
